import { render, staticRenderFns } from "./LibrariesList.vue?vue&type=template&id=5a597458&scoped=true&"
import script from "./LibrariesList.vue?vue&type=script&lang=js&"
export * from "./LibrariesList.vue?vue&type=script&lang=js&"
import style0 from "./LibrariesList.vue?vue&type=style&index=0&id=5a597458&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a597458",
  null
  
)

export default component.exports